import { render, staticRenderFns } from "./cDataCaptureHierarchy.vue?vue&type=template&id=46b6178b&scoped=true"
import script from "./cDataCaptureHierarchy.vue?vue&type=script&lang=js"
export * from "./cDataCaptureHierarchy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b6178b",
  null
  
)

export default component.exports